module.exports = __webpack_public_path__ + "static/media/FEDEX.463eb10e.svg";